// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d98681c6","239":"af4176fe","667":"342b4457","885":"557aaa37"}[chunkId] + ".chunk.js";
};